<template>
  <div class="Loader-Container">
    <Spinner />
  </div>
</template>

<script>
import Spinner from '../layout/Spinner'
export default {
  name: 'Loader',
  components: {
    Spinner
  },
  props: {
    text: {
      type: String,
      default: 'global.loading'
    }
  }
}
</script>

<style lang="scss">
.Loader-Container {
  padding-top: 10px;
  margin-left: 10px;
  min-height: 40px;
}
</style>
